import { ReactNode, useEffect, useRef, useState } from 'react';
import { CssFuncs } from '../../../../foundation/css/css.funcs';
import { Rect } from '../../../../foundation/geometry/rect';
import { RectFuncs } from '../../../../foundation/geometry/rect.funcs';
import { JsFuncs } from '../../../../foundation/js/js.funcs';
import { PopupEffectStyle } from './popup-effect.style';
import { PopupPosition } from './popup-position';
import { PopupPositionFuncs } from './popup-position.funcs';

export function PopupEffect({
  component,
  triggerRect,
  positions,
  zIndex,
}: {
  component: ReactNode;
  triggerRect: Rect;
  positions: PopupPosition[];
  zIndex: number;
}) {
  const containerRef = useRef<HTMLDivElement>(null);
  const [position, setPosition] = useState<Rect | null>(null);

  useEffect(() => {
    if (JsFuncs.isNotNull(position)) {
      return;
    }

    const rect = RectFuncs.from(containerRef.current?.getBoundingClientRect() ?? {});
    const boundaryRect = RectFuncs.from({ x: 0, y: 0, width: window.innerWidth, height: window.innerHeight });

    const bestPosition =
      PopupPositionFuncs.getBestPosition({
        triggerRect,
        popupRect: rect,
        boundaryRect,
        positions,
      }) ?? null;

    setPosition(bestPosition);
  }, [position]);

  return (
    <PopupEffectStyle.Container
      ref={containerRef}
      className={CssFuncs.className((names) => {
        names.push(JsFuncs.isNotNull(position) ? 'is-positioned' : 'is-not-positioned');
      })}
      style={{
        zIndex,
        ...(JsFuncs.isNotNull(position) ? { left: position!.x, top: position!.y, width: position!.width, height: position!.height } : {}),
      }}
    >
      {component}
    </PopupEffectStyle.Container>
  );
}
